import { AngularEditorModule } from "@angular-editor/angular-editor.module";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Router } from "@angular/router";
import { CHAButtonsModule } from "@app/shared/buttons/chabuttons.module";
import { CHABreadcrumbsModule } from "@app/shared/chabreadcrumbs/chabreadcrumbs.module";
import { MessageMasterModule } from "@app/shared/messagemaster/messagemaster.module";
import { ToastMasterModule } from "@app/shared/toastmaster/toastmaster.module";
import { AuthInterceptor, fakeBackendProvider, OktaInterceptor, UserAuditRequestInterceptor } from "@appcore/_helpers";
import { AlertComponent } from "@appcore/components/alerts";
import { EmailValidationComponent } from "@appcore/components/emailValidation/emailValidation.component";
import { environment } from "environments/environment";
import { NgIdleModule } from "@ng-idle/core";
import { OKTA_CONFIG, OktaAuthModule } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";
import { AuthenticationConfiguration, AuthenticationServiceProvider } from "@service/auth";
import { AuthorizationService } from "@service/auth/authorization.service";
import { ColorUtility, CookieService, HttpManager, ResponseHandler, Utilities } from "@service/system";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ChartModule } from "primeng/chart";
import { CheckboxModule } from "primeng/checkbox";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { FieldsetModule } from "primeng/fieldset";
import { InplaceModule } from "primeng/inplace";
import { InputMaskModule } from "primeng/inputmask";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { MultiSelectModule } from "primeng/multiselect";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PanelModule } from "primeng/panel";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SplitButtonModule } from "primeng/splitbutton";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { ToggleButtonModule } from "primeng/togglebutton";
import { TooltipModule } from "primeng/tooltip";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import config from "./app.config";
import { ClientOrganizationDetail } from "./components/client/customization/organization-detail.component";
import { HomeComponent } from "./components/home/home.component";
import { LoginComponent } from "./login";
import { LogoutComponent } from "./logout";
import { MessagesComponent } from "./messages/messages.component";
import { AppFooterComponent } from "./newNav/app.footer.component";
import { AppMenuComponent } from "./newNav/app.menu.component";
import { AppTopBarComponent } from "./newNav/app.topbar.component";
import { RegisterComponent } from "./register";

import * as $ from "jquery";

config.oidc.postLogoutRedirectUri = environment.appBaseHref;

function onAuthRequired(oktaAuth, injector) {
	// Use injector to access any service available within your application
	const router = injector.get(Router);

	// Redirect the user to your custom login page
	router.navigate([""]);
}

const oktaAuth = new OktaAuth(config.oidc);

@NgModule({
	declarations: [
		AlertComponent,
		AppComponent,
		AppFooterComponent,
		AppMenuComponent,
		AppTopBarComponent,
		ClientOrganizationDetail,
		HomeComponent,
		LoginComponent,
		LogoutComponent,
		MessagesComponent,
		RegisterComponent,
		EmailValidationComponent
	],
	imports: [
		AngularEditorModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		BrowserModule,
		ButtonModule,
		CardModule,
		CHABreadcrumbsModule,
		CHAButtonsModule,
		ChartModule,
		CheckboxModule,
		ClipboardModule,
		ConfirmDialogModule,
		DialogModule,
		DropdownModule,
		FieldsetModule,
		FormsModule,
		HttpClientModule,
		InplaceModule,
		InputMaskModule,
		InputSwitchModule,
		InputTextareaModule,
		InputTextModule,
		MessageMasterModule,
		MultiSelectModule,
		NgIdleModule.forRoot(),
		OktaAuthModule,
		OverlayPanelModule,
		PanelModule,
		ProgressSpinnerModule,
		ReactiveFormsModule,
		SplitButtonModule,
		TableModule,
		TabViewModule,
		ToastMasterModule,
		ToggleButtonModule,
		TooltipModule
	],
	providers: [
		{ provide: AuthenticationConfiguration },
		AuthenticationServiceProvider,
		{ provide: AuthorizationService },
		{ provide: HttpManager },
		{ provide: ResponseHandler },
		{ provide: LocationStrategy, useClass: PathLocationStrategy },
		{ provide: OKTA_CONFIG, useValue: { oktaAuth, onAuthRequired } },
		// ---------------------------
		// APP_BASE_HREF will override <base href="./">, which is needed for asset src resolution.
		// However, APP_BASE_HREF also controls route path resolution, so (for us) they need to remain separate
		// NOTE: The value provided here (environment.appBaseHref) is just a convenience variable located in the env files
		// There also exists an "altBaseHref" value should we need to use that as an alternative for route paths/login resolution.
		// --------------------------
		// , { provide: APP_BASE_HREF, useValue: environment.appBaseHref }
		// { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: OktaInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: UserAuditRequestInterceptor, multi: true },

		// provider used to create fake backend
		ColorUtility,
		CookieService,
		fakeBackendProvider,
		Utilities
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
